import React from 'react'
import Style from './index.style'

const CardImage = ({
  image,
  desc,
  title,
  noFluid = false,
  titleTop = true,
  imageFix = false,
  noShadow = true,
  styleImage = {},
  style = {},
  styleText = {}
}) => {
  return (
    <Style
      style={{ ...style }}
      noShadow={noShadow}
      className="card-image-box"
      imageFix={imageFix}
      noFluid={noFluid}
    >
      {titleTop ? <div className="title top">{title}</div> : false}

      <img
        className="card-image"
        style={{ ...styleImage }}
        src={image}
        alt="halojasa/card-image"
      />
      <div className="text">
        {!titleTop ? (
          <div className="title" style={{ ...styleText }}>
            {title}
          </div>
        ) : (
          false
        )}
        <div className="desc">{desc}</div>
      </div>
    </Style>
  )
}

export default CardImage
